/* cart-vid-stamp.js
 * Stamps OUR visitor_id + session id into the Shopify cart as attributes, so
 * they ride into the hosted checkout as note_attributes. Downstream readers:
 *   - vid-email-resolve /shopify/abandoned-checkout (checkouts/create|update
 *     webhook): ties {email + visitorID} in users_drip AND forwards a PII-free
 *     checkout_update analytics event (SE_SessionId links it to the shopper's
 *     storefront events in BigQuery).
 *   - the order webhook (process_order): reads SE_SessionId + visitorID from
 *     the order's note_attributes onto the BigQuery `purchase` event.
 * Checkout is Shopify-hosted, so cart attributes are the only bridge.
 *
 * Session id chain mirrors cae-client's getSessionId(): the engine's
 * SE_SessionId when present (ROW), else cae-client's CAE_SESSION_ID (EU/IL
 * run no engine), else mint into CAE_SESSION_ID so every reader agrees on one
 * id. The attribute KEY is always SE_SessionId - that's what consumers read.
 *
 * Writes once per session per (vid, sid), best-effort, fire-and-forget.
 * /cart/update.js MERGES attributes (doesn't clobber other cart attributes).
 */
(function () {
  'use strict';

  function visitorId() {
    try {
      if (window.SE_visitorIdentity && window.SE_visitorIdentity.visitor_id) {
        return window.SE_visitorIdentity.visitor_id;
      }
    } catch (e) {}
    try { return localStorage.getItem('visitorID') || null; } catch (e) { return null; }
  }

  function sessionId() {
    try {
      var sid = sessionStorage.getItem('SE_SessionId');
      if (sid) return sid;
      sid = sessionStorage.getItem('CAE_SESSION_ID');
      if (sid) return sid;
      sid = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : 'u-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem('CAE_SESSION_ID', sid);
      return sid;
    } catch (e) { return null; }
  }

  function stamp() {
    // SAFETY GATE (session-guard.js) — see the ROW pilot for the full rationale.
    // Stamping an identity into the cart writes it into a REAL Shopify order;
    // denied for every non-shopper session. Fails closed if the guard is absent.
    try {
      if (window.SE_Session) {
        if (!window.SE_Session.allow('cart-stamp', 'cart attribute')) return;
      } else {
        // Guard asset missing (404 / parse error / not yet pushed). An "assumed"
        // session is IMPOSSIBLE without it — begin() lives in the guard — so the
        // legacy prefix check is a COMPLETE substitute here, and a real shopper
        // is never broken by a missing file. Fail-safe, not fail-dark.
        var _gv = ''; try { _gv = localStorage.getItem('visitorID') || ''; } catch (e2) {}
        if (_gv.indexOf('facade00-') === 0 || _gv.indexOf('staff00-') === 0) return;
      }
    } catch (e) { /* never block a real shopper on the guard itself */ }
    var vid = visitorId();
    if (!vid) return;
    var sid = sessionId();
    var flag = 'AGB_cartvid_' + vid + '|' + (sid || '');
    try { if (sessionStorage.getItem(flag)) return; } catch (e) {}
    var attrs = { visitorID: vid };
    if (sid) attrs.SE_SessionId = sid;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        try { sessionStorage.setItem(flag, '1'); } catch (e) {}
      }).catch(function () {});
    } catch (e) { /* fire-and-forget */ }
  }

  if (document.readyState !== 'loading') stamp();
  else document.addEventListener('DOMContentLoaded', stamp);
  // vid often resolves AFTER load (scarcity engine) -> stamp when it announces.
  window.addEventListener('SE_visitorIdentified', stamp);
})();
